class LiquidGlassMenuSticky extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('.liquid-glass-menu');
    this.cartProxy = this.querySelector('[data-cart-drawer-proxy]');
    this.mobileMenu = this.querySelector('.liquid-glass-menu__mobile-menu');
    this.onCartClick = this.onCartClick.bind(this);
    this.onMenuToggle = this.onMenuToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onResize = this.onResize.bind(this);
    this.cartProxy?.addEventListener('click', this.onCartClick);
    this.mobileMenu?.addEventListener('toggle', this.onMenuToggle);
    this.mobileMenu?.addEventListener('click', this.onMenuClick);
    document.addEventListener('keydown', this.onKeydown);
    window.addEventListener('resize', this.onResize, { passive: true });
    if (!this.header || this.dataset.sticky !== 'true') return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    this.cartProxy?.removeEventListener('click', this.onCartClick);
    this.mobileMenu?.removeEventListener('toggle', this.onMenuToggle);
    this.mobileMenu?.removeEventListener('click', this.onMenuClick);
    document.removeEventListener('keydown', this.onKeydown);
    document.documentElement.classList.remove('liquid-glass-menu-open');
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  onCartClick(event) {
    const drawer = this.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open();
  }

  onMenuToggle() {
    document.documentElement.classList.toggle('liquid-glass-menu-open', Boolean(this.mobileMenu?.open));
  }

  onMenuClick(event) {
    if (event.target instanceof Element && event.target.closest('a[href]')) {
      this.mobileMenu.open = false;
      this.onMenuToggle();
    }
  }

  onKeydown(event) {
    if (!this.mobileMenu?.open) return;
    if (event.key === 'Escape') {
      this.mobileMenu.open = false;
      this.mobileMenu.querySelector('summary')?.focus();
    } else if (event.key === 'Tab') {
      const controls = [...this.mobileMenu.querySelectorAll('summary, a[href], button:not([disabled]), [tabindex="0"]')]
        .filter((element) => element.getClientRects().length > 0);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }
  }

  onResize() {
    if (window.matchMedia('(min-width: 1200px)').matches && this.mobileMenu?.open) {
      this.mobileMenu.open = false;
      this.onMenuToggle();
    }
    if (!this.header || this.dataset.sticky !== 'true') return;
    this.header.dataset.fixed = 'false';
    this.style.minHeight = '0px';
    this.threshold = this.getBoundingClientRect().top + window.scrollY;
    this.style.minHeight = `${this.header.offsetHeight}px`;
    this.onScroll();
  }

  onScroll() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.header.dataset.fixed = String(window.scrollY >= this.threshold);
    });
  }
}

if (!customElements.get('liquid-glass-menu-sticky')) {
  customElements.define('liquid-glass-menu-sticky', LiquidGlassMenuSticky);
}
